import React from "react";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ClipboardCheck } from "lucide-react";

export default function AdminChecklist({ clientId, checklist = [], onChange }) {
  const toggle = async (item, field) => {
    try {
      await api.post(`/admin/clients/${clientId}/checklist`, {
        key: item.key,
        [field]: !item[field],
      });
      onChange?.();
    } catch { toast.error("Update failed"); }
  };

  return (
    <Card className="p-6 rounded-2xl border-slate-100" data-testid="admin-checklist-card">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-9 h-9 rounded-xl bg-sky-100 text-sky-700 flex items-center justify-center"><ClipboardCheck size={18} /></div>
        <div>
          <h3 className="font-display font-bold text-lg">Requested documents</h3>
          <p className="text-xs text-slate-500">Toggle "Requested" to show items to the client. Mark "Received" once you have them.</p>
        </div>
      </div>
      <div className="space-y-2">
        {checklist.map((item) => (
          <div key={item.key} className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 border border-slate-100" data-testid={`checklist-item-${item.key}`}>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-semibold ${item.received ? "line-through text-slate-400" : "text-slate-800"}`}>{item.label}</p>
            </div>
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600 cursor-pointer">
              <Checkbox checked={item.requested} onCheckedChange={() => toggle(item, "requested")} data-testid={`req-${item.key}`} />
              Requested
            </label>
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600 cursor-pointer">
              <Checkbox checked={item.received} onCheckedChange={() => toggle(item, "received")} data-testid={`rcv-${item.key}`} />
              Received
            </label>
          </div>
        ))}
        {checklist.length === 0 && <p className="text-sm text-slate-400">No checklist available.</p>}
      </div>
    </Card>
  );
}
